import lazyLoading from './lazyLoading'

export default {
  name: 'tickets',
  meta: {
    expanded: false,
    title: 'Finanzas',
    iconClass: 'fa fa-money'
  },
  children: [
    /*
    {
      name: 'payments',
      path: '/payments',
      component: lazyLoading('app/payments/PaymentList'),
      meta: {
        title: 'Consulta Pagos',
        requiresAuth: true
      }
    },
    */
    {
      name: 'dashboardCharts',
      path: '/financial/dashboard-charts',
      component: lazyLoading('app/dashboardCharts/DashboardCharts'),
      meta: {
        title: 'Dashboard de Ventas',
        requiresAuth: true
      }
    },
    {
      name: 'cobros',
      path: '/cobros',
      component: lazyLoading('app/debitPayments/DebitPaymentList'),
      meta: {
        title: 'Consulta Cobros',
        requiresAuth: true
      }
    },
    {
      name: 'pagos',
      path: '/pagos',
      component: lazyLoading('app/payments/PaymentListTab'),
      meta: {
        title: 'Consulta Pagos',
        requiresAuth: true
      }
    },
    /*
    {
      path: '/financial/aircab-sales',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Aircab Venta'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/AircabList'),
          meta: {
            title: 'Lista Aircab'
          }
        }
      ]
    },
    {
      path: '/financial/aircab-scheduled-sales',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Aircab Vuelta Venta'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/AircabScheduledList'),
          meta: {
            title: 'Lista Vuelta Aircab'
          }
        }
      ]
    },
    */
    /*
    {
      path: '/financial/daily-sales',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Ventas del Día'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/DailySalesList'),
          meta: {
            title: 'Ventas del Día'
          }
        },
        {
          path: ':dailySaleId',
          component: lazyLoading('financial/DailySalesDetail'),
          props: true,
          meta: {
            title: 'Detalle del venta del día'
          }
        }
      ]
    },
    */
    {
      name: 'ticketsFinancialDeposits',
      path: '/financial/deposits',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Pagos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/DepositList'),
          meta: {
            title: 'Pagos'
          }
        },
        {
          name: 'depositDetail',
          path: ':depositId',
          component: lazyLoading('financial/DepositDetail'),
          props: true,
          meta: {
            title: 'Detalle del Pago'
          }
        }
      ]
    },
    {
      name: 'clarificationTicket',
      path: '/utils/clarification-ticket',
      component: lazyLoading('tools/AssignTicket'),
      meta: {
        title: 'Aclaración de Boletos',
        requiresAuth: true
      }
    },
    {
      name: 'ticketsDebits',
      path: '/debits',
      component: lazyLoading('app/debits/Main'),
      meta: {
        title: 'Adeudos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/debits/List'),
          meta: {
            title: 'Adeudos'
          }
        },
        {
          path: ':debitId',
          component: lazyLoading('app/debits/View'),
          props: true,
          meta: {
            title: 'Adeudo'
          },
        },
      ]
    },
    {
      name: 'InvoiceList',
      path: '/invoices',
      component: lazyLoading('app/invoices/InvoiceList'),
      meta: {
        title: 'Facturas Emitidas',
        requiresAuth: true
      }
    },
    {
      name: 'financialTicketScheduled',
      path: '/financial/ticket-scheduled',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Retornos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/TicketScheduledList'),
          meta: {
            title: 'Ticket Retorno Asignados'
          }
        }
      ]
    },
    {
      name: 'sales',
      path: '/sales',
      component: lazyLoading('app/sales/List'),
      meta: {
        title: 'Ventas',
        requiresAuth: true
      }
    },
    {
      name: 'financialAircabSalesCompany',
      path: '/financial/aircab-sales-company',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Aircab Venta'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/Company/AircabList'),
          meta: {
            title: 'Lista Aircab'
          }
        }
      ]
    },
    {
      name: 'financialCallcenterSalesCompany',
      path: '/financial/callcenter-sales-company',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Callcenter Venta'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('financial/Company/CallcenterList'),
          meta: {
            title: 'Lista Callcenter'
          }
        }
      ]
    },
    {
      name: 'driverCut',
      path: '/utils/driver-cut',
      component: lazyLoading('tools/DriverCut'),
      meta: {
        title: 'Corte Por Unidad',
        requiresAuth: true
      }
    },
    {
      name: 'driverCut',
      path: '/utils/deposit-list-car',
      component: lazyLoading('financial/DepositListCar'),
      meta: {
        title: 'Pagos por Unidad',
        requiresAuth: true
      }
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/tickets.js